import script from "./arcticleDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./arcticleDetail.vue?vue&type=script&setup=true&lang=js"

import "./arcticleDetail.vue?vue&type=style&index=0&id=7603cae6&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7603cae6"]])

export default __exports__